import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt from "jwt-decode";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import loanFileService from "../../../services/loanFileService";
import claimLoginServices from "../../../services/claimLoginServices";
import { instanceToken } from "../../../utils/constant";

export default function LoanFiles() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [loanFiles, setLoanFiles] = useState(null);
  const [search, setSearch] = useState("");

  const [values] = useState({
    username: "admin-1",
    password: "Secret@CBL$$SmartCart2025",
  });

  useEffect(() => {
    if (search === "") {
      fetchLoanFiles(rowsPerPage, offset);
    } else {
      fetchSearchByInsuranceID(search);
    }
  }, [offset, rowsPerPage, search]);

  const fetchSearchByInsuranceID = async (searchValue) => {
    try {
      const res = await loanFileService.getLoanFile(
        instanceToken.token,
        searchValue
      );
      if (res.data) {
        const uniqueResults = Array.from(
          new Map(res.data.map((item) => [item.insurance_id, item])).values()
        );
        setLoanFiles(uniqueResults);
        setCount(uniqueResults.length);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLoanFiles = async (limit, offset) => {
    try {
      const res = await loanFileService.getLoanFiles(
        instanceToken.token,
        limit,
        offset
      );
      setLoanFiles(res.data.loan_files);
      setCount(res.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(0);
    setOffset(0);
  };

  const handleDetailsClick = async (insurance_id) => {
    try {
      const response = await claimLoginServices.ClaimLogin({
        username: values.username,
        password: values.password,
      });

      const token = response.data.token;
      const decodedToken = jwt(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        console.log("Session expired");
        return;
      }

      const data = JSON.stringify({
        decodedToken,
        jwttoken: token,
      });
      window.localStorage.setItem("cblife_claimForm_token", data);

      navigate(`/loanFiles/${insurance_id}`);
    } catch (error) {
      console.error("Error during login or navigation:", error);
    }
  };

  const openDetail = (row) => handleDetailsClick(row.insurance_id);

  const columns = [
    {
      id: "insurance_id",
      label: "Insurance ID",
      render: (row) => <TruncatedCell value={row.insurance_id} />,
    },
  ];

  return (
    <DataListPage
      title="Loan Files"
      rows={loanFiles || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[10, 25]}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      search={{
        placeholder: "Search by insurance ID...",
        onSearch: handleSearch,
        showFilterButton: false,
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      getRowKey={(row, index) => row.insurance_id ?? index}
      loading={!loanFiles}
    />
  );
}
